import { styled } from '../theme';

export const Layout = styled.div`
  width: 30rem;
  padding: 1rem;
  border: 1px solid ${props => props.theme.color.lightShade};
  border-radius: 10px;
  box-shadow: 0 8px 29px -6px rgba(0, 0, 0, 0.1);
`;
